{
  "aiGeneratedAnswer": "AI生成された回答",
  "allCategories": "すべてのカテゴリー",
  "appliedFiltersToCurrentSearch": "現在の検索に適用されたフィルター",
  "apply": "適用",
  "applyFilters": "フィルターを適用",
  "autocompleteOptionsFound_other": "{{label}}のオートコンプリート候補が{{count}}件見つかりました。",
  "autocompleteSuggestion": "オートコンプリートの提案：{{suggestion}}",
  "autocompleteSuggestionsFound_other": "{{count}} 件のオートコンプリート候補が見つかりました。",
  "basedOnYourDevice": "（デバイスに基づく）",
  "basedOnYourInternetAddress": "（インターネットアドレスに基づく）",
  "categoriesText_other": "次のカテゴリでは、 -  <strong> {{query}} </strong>の結果が得られました",
  "clearAll": "すべてをクリアします",
  "clearMinAndMax": "最小値と最大値をクリア",
  "clearTheRangeToSelectOptions": "範囲をクリアしてオプションを選択します。",
  "clearTheSearchBar": "検索バーをクリアします",
  "conductASearch": "検索を実施します",
  "currentLocation": "現在地",
  "didYouMean": "<button>{{correctedQuery}}</button> と言いたかったですか",
  "dropDownScreenReaderInstructions": "オートコンプリート結果が利用可能な場合、↑↓キーで選択し、Enter キーで選択。",
  "feedback": "フィードバック",
  "invalidRange": "無効な範囲",
  "max": "最大",
  "min": "最小",
  "navigateToTheNextResultsPage": "次の結果ページに移動します",
  "navigateToThePreviousResultsPage": "前の結果ページに移動します",
  "noAutocompleteOptionsFound": "オートコンプリート オプションが 0 件見つかりました。",
  "noAutocompleteSuggestionsFound": "オートコンプリート候補が 0 件見つかりました。",
  "noResultsFoundIn": "{{currentVerticalLabel}}で結果が見つかりませんでした。",
  "pagination": "ページネーション",
  "readMoreAbout": "<a>{{name}}</a> について詳しく読む",
  "recentSearch": "最近の検索：{{query}}",
  "recentSearchesFound_other": "{{count}} 件の最近の検索が見つかりました。",
  "removeFilter": "「{{displayName}}」 フィルターを削除",
  "resultPreview": "結果プレビュー：{{value}}",
  "resultPreviewsFound_other": "{{count}} 件の結果プレビューが見つかりました。",
  "resultsCountText_other": "{{count}}件",
  "resultsCountWithPaginationText": "{{paginateStart}}〜{{paginateEnd}}／全{{resultsCount}}件",
  "searchHere": "ここで検索…",
  "showLess": "折りたたむ",
  "showMore": "もっと見る",
  "showingAllInstead": "代わりにすべての{{currentVerticalLabel}}を表示しています。",
  "sources_other": "出典（{{count}}）",
  "submitSearch": "検索を送信します",
  "suggestionResultsCount_other": "{{label}} – {{count}} 件の結果",
  "thankYouForYourFeedback": "ご意見ありがとうございます！",
  "thisAnsweredMyQuestion": "この回答で疑問が解決しました",
  "thisDidNotAnswerMyQuestion": "この回答では疑問が解決しませんでした",
  "unselectAnOptionToEnterInARange": "範囲を入力するには、選択を解除してください。",
  "updateYourLocation": "あなたの場所を更新します",
  "useCurrentLocation": "現在地を使用",
  "useMyLocation": "現在地を使用",
  "viewAll": "すべてを表示します",
  "viewDetails": "詳細を表示します"
}
